import(/* webpackMode: "eager", webpackExports: ["DiscountProvider"] */ "/app/src/app/[locale]/product/_contexts/DiscountProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/product/_contexts/PDPProvider.tsx");
